import React, { Component } from 'react';

import '../../css/bg.css';
import '../../css/main-page.css';
import '../../css/gallery.css';

import routeConfig from '../../config/route.json';
import comingSoonConfig from '../../config/coming-soon.json';

import $ from 'jquery';
import ScrollArea from 'react-scrollbar';

class Gallery extends Component {

  constructor(props) {
    super(props);
    // let lang = window.location.hash.split('/')[1];
    let pathArr = window.location.pathname.split('/');
    let lang = pathArr[2] === '' ? 'en' : pathArr[2];


    this.state = {
      ...this.props,
      bg: {
        pic1: '/p2/desktop/bg/' + lang + '/gallary/main.png',
        pic2: '/p2/desktop/bg/' + lang + '/gallary/2.png',
        pic3: '/p2/desktop/bg/' + lang + '/gallary/3.png',
        pic4: '/p2/desktop/bg/' + lang + '/gallary/4.png'
      },
      lang: lang,
      imageIndex: 0,
      image: ''
    }
    this.openImage = this.openImage.bind(this);
    this.closeImage = this.closeImage.bind(this);
    this.closeImage = this.closeImage.bind(this);
    $('#loader').fadeIn();
  }
  
  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;

    const toFunc = function(){
      console.log('polling t.props.data...')
      if (typeof t.props.data !== 'undefined') {
        t.setState({
          data: t.props.data
        });
        t.changePositioning();
      } else {
        t.t0 = setTimeout(toFunc, 500);
      }
    }

    this.t0 = setTimeout(toFunc, 500);

    console.log('Gallery DidMount')
    $( '#bg-image-1' ).on('load', function() {
      t.pageLoad();
    });

    this.props.updateLang();
    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);

  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);
    this.closeImage();
    
    clearTimeout(this.t0);

    clearTimeout(this.bgAnimTimeout1);
    clearTimeout(this.bgAnimTimeout2);
    clearTimeout(this.bgAnimTimeout3);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();

    // const ratio = 4268 / 2786;
    // const mainBg = $('#bg-image-1');
    // mainBg.css({ minWidth: mainBg.height() * ratio });

    this.bgAnimTimeout1 = setTimeout(function(){
      document.getElementById('bg-image-2').classList.remove('bg-flower');
    }, 2200);
    this.bgAnimTimeout2 = setTimeout(function(){
      document.getElementById('bg-image-3').classList.remove('bg-flower');
    }, 3000);
    this.bgAnimTimeout3 = setTimeout(function(){
      document.getElementById('bg-image-4').classList.remove('bg-flower');
    }, 3900);
  }

  changePositioning() {
    let windowWidth = $('.App').width();

    if (windowWidth < 1100) {
      windowWidth = 1100
    }


    // let bgImage2Top = windowWidth * 0.238632727 + 'px';
    let bgImage3Top = windowWidth * 550/1300 + 'px';

    // document.getElementById('bg-image-2-container').style.top = bgImage2Top;
    document.getElementById('bg-image-3-container').style.top = bgImage3Top;

    $('.gallary-image-pre').css({
      height: $('.gallary-image-pre').width() * 0.35 + 'px',
      padding: $('.gallary-image-pre').width() * 0.35 + 'px 0 0 0'
    })
    
  }



  openImage(imgIdx){
    
    this.setState({
      'imageIndex': imgIdx,
      'image': this.state.data.gallery[imgIdx].img
    })

    $('.gallary-image').fadeIn()
    $('#App-header').fadeOut()
    $('#App-footer').fadeOut()
  }

  closeImage(){
    this.setState({
      'image': ''
    })
    $('.gallary-image').fadeOut()
    $('#App-header').fadeIn()
    $('#App-footer').fadeIn()
  }

  changeImage(move) {
    let t = this;
    let nowIdx = t.state.imageIndex;
    let nextIdx = 0;

    let result = 0;

    function nextIdxer(nowIdx, move){
      if (!t.state.data.gallery[nowIdx + move]) {
        return -1;
      } else
      if (!t.state.data.gallery[nowIdx + move].img) {
        return nextIdxer(nowIdx + move, move)
      } else {
        return nowIdx + move
      }
    }

    result = nextIdxer(nowIdx, move)
    if (result === -1) {
      nextIdx = nowIdx
    } else {
      nextIdx = result
    }

    console.log(nextIdx)

    this.setState({
      imageIndex: nextIdx,
      image: t.state.data.gallery[nextIdx].img
    })
  }

  isInt = (value) => {
    return !isNaN(value) && 
           parseInt(Number(value)) == value && 
           !isNaN(parseInt(value, 10));
  }
  
  render() {
    let t = this;
    return <div className='main-page' style={{}}>

        <img src={this.state.bg.pic1} className='bg-image main-bg-image' id='bg-image-1' style={{
          
        }}/>

        <div id='bg-image-2-container'
          className='bg-image-container'
          style={{
            right: '0',
            width: '19%'
          }}>
          <img src={this.state.bg.pic2} className='bg-image bg-flower' id='bg-image-2'/>
        </div>

        <div id='bg-image-3-container'
          className='bg-image-container'
          style={{
            right: '0',
            width: '42%'
          }}>
          <img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3'/>
        </div>

        <div id='bg-image-4-container'
          className='bg-image-container'
          style={{
            left: '0',
            width: '24%'
          }}>
          <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4'/>
        </div>





        <div id='main-page-content-container-1'
          className='main-page-content-container'
          style={{
            left: '10%',
            width: '34%',
            top: '49%',
            height: '200px',
            maxWidth: '100%'
          }}>

          <div
            className='main-page-content-subtitle'
            style={{
              // textAlign: 'center',
              fontSize: '20px',
              textShadow: '1px 1px 2px rgba(0,0,0,1)'
            }}>
            {this.state.lang === 'en' ? 
              <img style={{height: '44px'}} src={routeConfig.gallery[this.state.lang].titleUrl}/> : 
              routeConfig.gallery[this.state.lang].name
            }
          </div>
          <ScrollArea
            speed={0.8}
            className='area'
            style={{
              // top: '20%',
              left: '-20px',
              height: 240 + 'px',
              width: 230 * 2 + 'px',
              // overflowY: 'visible',
              overflowY: 'hidden',
            }}
            contentClassName='content'
            contentStyle={{
              height: (
                this.state.data && this.state.data.gallery && this.state.data.gallery.length > 0 ?
                  (Math.ceil(this.state.data.gallery.length / 2)) * 163 + 'px' :
                  ''

                  // this.isInt(this.state.data.gallery.length) ?
                  //   this.state.data.gallery.length / 2 * 163 + 'px' :
                  //   (Math.floor(this.state.data.gallery.length / 2) + 1) * 163 + 'px'
                  // :
                  // ''
              ),
              width: 215 * 2 + 'px',
            }}
            // verticalContainerStyle={{
            //   opacity: '0.6',
            //   height: '9px',
            //   borderRadius: '4.5px',
            //   backgroundColor: 'white',
            //   zIndex: '1000',
            // }}
            verticalScrollbarStyle={{
              marginTop: '0',
              height: '9px',
              borderRadius: '4.5px',
              // backgroundColor: '#ecacd2',
              backgroundColor: 'white',
            }}
            
            horizontal={false}
            vertical={true}
            >
            {this.state.data && this.state.data.gallery && this.state.data.gallery.length > 0 ?
              this.state.data.gallery.map(function(elem, idx){
                let renderType = elem.img ? 'img' : 'pdf';
                let objToRender = '';
                if (renderType === 'img') {
                  let imgSrc = 'url(' + elem.img + ')';
                  objToRender = <div key={idx} className='gallary-image-pre' style={{
                    backgroundImage: imgSrc
                  }} onClick={() => t.openImage(idx)}>
                  </div>
                }
                else {
                  objToRender = <a key={idx} href={elem.url} target='_blank'><div className='gallary-image-pre' style={{
                    color: 'white',
                    fontFamily: 'Roboto Condensed, sans-serif',
                    backgroundImage: 'url(/p2/desktop/gallery/bg-for-non-image.png)'
                  }}>
                    {elem[t.state.lang]}
                  </div></a>
                }
                return objToRender

              }) : <div style={{
                  color: 'white',
                  padding: '6px 26px',
                  textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px, rgba(0, 0, 0, 0.5) 1px 1px 1px, rgba(0, 0, 0, 0.5) 1px 1px 2px',
                  // textAlign: 'center'
                }}>{comingSoonConfig[t.state.lang]}</div>
              }
          </ScrollArea>


        </div>


        <div className='gallary-image' style={{
          zIndex: '1050'
        }}>

            <img src={this.state.image} className='centering' style={{
              maxWidth: '82%',
              maxHeight: '95%'
            }}/>
          <img src='/p2/desktop/gallery/left.png' className='gallary-lr' style={{
            left: '50px'
          }} onClick={() => t.changeImage(-1)}/>
          <img src='/p2/desktop/gallery/right.png' className='gallary-lr' style={{
            right: '50px'
          }} onClick={() => t.changeImage(1)}/>
          <i className='material-icons gallary-lr' style={{
            top: '25px',
            right: '25px',
            fontSize: '50px',
            color: 'rgb(51, 102, 199)'
          }} onClick={this.closeImage}>clear</i>
        </div>
        
    </div>
  }
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/desktop/page/Gallery.js